<template>
    <iframe :src='$route.query.src' class="main-iframe" :style="{height:this.$store.getters.iframeHeight+'px'}" ></iframe>
</template>

<script>
export default {
  name: "main-iframe",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  props: [],
  watch: {},
  components: {},
  methods: {}
};
</script>

<style>
.main-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  overflow: hidden;
  box-sizing: border-box;
}
</style>
